import type { ConnectedFacility } from '../../../../../js/api';
import { QueueCodes, StatusCodes } from '../../../constants/workflows';

type Props = {
  connectionsProvActionReq: ConnectedFacility[];
};

export function ConnectionsProviderActionRequested({ connectionsProvActionReq }: Props) {
  if (connectionsProvActionReq.length === 0) {
    return null;
  }

  const handleClick = () => {
    window.location.href = `/app/provider/connections?queue=${QueueCodes.NEEDS_RESPONSE}&status=${StatusCodes.PROV_ACTION_REQ}`;
  };

  return (
    <div
      role="button"
      tabIndex={0}
      onClick={handleClick}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          handleClick();
        }
      }}
      className="tw:bg-red-100 tw:rounded-xl tw:p-4 tw:border tw:border-red-300/20 tw:hover:bg-red-300/20 tw:transition-colors tw:cursor-pointer"
    >
      <div className="tw:flex tw:items-start tw:gap-3">
        <div className="tw:w-10 tw:h-10 tw:sm:w-12 tw:sm:h-12 tw:shrink-0 tw:bg-stoplight-danger tw:rounded-full tw:flex tw:items-center tw:justify-center">
          <i className="fas fa-fw fa-comment-exclamation tw:text-white tw:text-base tw:sm:text-lg" />
        </div>
        <div className="tw:flex-col">
          <div className="tw:font-medium tw:text-stoplight-danger tw:hover:underline">
            {connectionsProvActionReq.length}{' '}
            {connectionsProvActionReq.length === 1
              ? 'Connection Needs Attention'
              : 'Connections Need Attention'}
          </div>
          {/* List of facilities and the current reason title */}
          <ul className="tw:mt-1 tw:list-disc tw:pl-1 tw:text-sm tw:text-zinc-700 tw:!mb-0">
            {connectionsProvActionReq.map((connection) => {
              const facilityName =
                connection.facility?.name ||
                connection.healthcare_entity?.name ||
                'Unknown Facility';
              const reasonTitle = connection.current_reason?.title ?? 'Needs Attention';
              return (
                <li key={connection.id} className="tw:mb-0.5">
                  <span className="tw:font-medium">{facilityName}</span> — {reasonTitle}
                </li>
              );
            })}
          </ul>
          <div className="tw:text-zinc-700 tw:text-sm">Click here to view and respond</div>
        </div>
      </div>
    </div>
  );
}

export default ConnectionsProviderActionRequested;
